import React from "react";
import HeroLayout from "../components/HeroLayout";

const images = require.context("../assets/images", false);
function Term_Condition() {
    
  
  return (
         <>
    <HeroLayout>
    <div
        className="banner-bg bgtop"
        style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./term&condition.jpg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Terms & Conditions</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
   
<div class="mt-80 about-GEH justify-content">
  <div className="container">
    <div className="row align-items-center">
<div className="col-md-12 termcondition">
  <h2>Terms & Conditions</h2>
  <h4><strong><u>General:</u></strong></h4>
  <ul><li>All hotels, flights and trains are subject to availability at the time of booking. Should your preferred property become unavailable, we will arrange an alternative of the same category or equivalent price range. This will be done with mutual understanding.</li>
  <li>We recommend reviewing hotel websites and images prior to finalising your booking. As perceptions of properties can vary, we are unable to accept responsibility for expectations formed independently online.</li>
  <li>Pricing, schedules and operational matters relating to hotels, flights and trains are managed directly by the respective service providers and are beyond our control. Any additional costs arising from changes, cancellations or delays — including resulting adjustments to your itinerary — will be borne by the client.</li>
  <li>Check-in, check-out and dining times are strictly governed by individual hotel policies. Early check-in and late check-out are subject to availability and hotel discretion.</li>
  <li>Unused tour components — including accommodation, meals, sightseeing or any other included service — are non-transferable and non-refundable.</li>
  <li>Any increase in costs arising from changes in fare structures, tax policies or other external factors will be passed on to the client at the prevailing rate.</li>
  <li>Air conditioning is generally not functional in hilly or mountainous regions, unless specifically stated otherwise.</li>
  <li>We reserve the right to modify, reschedule or cancel any tour, route or service where circumstances beyond our control make this necessary. We appreciate your understanding that such decisions are always made with your best interests and safety in mind.</li></ul>

<h4><strong><u>Travel Insurance:</u></strong></h4>
<ul>
<li>Our tour packages do not include travel insurance. As such, any costs arising from unforeseen circumstances — including medical emergencies, theft, adverse weather, natural disasters or political disruption — remain the client's responsibility.</li>
<li>While our team is fully committed to your comfort, safety and wellbeing throughout your journey, we strongly recommend that all travellers obtain comprehensive travel insurance prior to departure. In today's world, it is an essential part of responsible travel planning.</li>
</ul>
<h4><strong><u>Payment:</u></strong></h4>
<p>To secure your Luxury Golden Triangle tour, we follow a simple and transparent payment schedule:</p>
<ul>
  <li><b>10%</b> deposit due at the time of booking to confirm your tour</li>
  <li><b>40%</b> due 90 days prior to your arrival date</li>
  <li><b>50%</b> due 45 days before your travel date</li>
</ul>
<p>For last-minute bookings or travel during the Christmas and New Year period, full payment of <b>100%</b> is required at the time of confirmation.</p>
<h4><strong><u>Payment Mode:</u></strong></h4>
<p>We offer two convenient payment methods — <b>Online payment via card</b> or <b>Wire transfer (bank to bank)</b>, whichever works best for you.</p>
<p><i>Please note: We reserve the right to cancel your tour if payment is not received in accordance with the above schedule.</i></p>
<h4><strong><u>Cancellation &amp; Refund:</u></strong></h4>
<h5><span style={{ color: "#333333" }}><strong>Land Package:</strong></span></h5>
<ul>
<li>Cancellation <b>90+ days</b> before travel: 10% cancellation charge applies; balance refunded minus transaction fees</li>
<li>Cancellation <b>89–46 days</b> before travel: 30% cancellation charge applies; balance refunded minus transaction fees</li>
<li>Cancellation <b>within 45 days</b> of travel: No refund applicable</li>
</ul>
<h5><span style={{ color: "#333333" }}>
  <strong>Flights:</strong>
</span>
</h5>
<ul>
<li>Flight cancellations and refunds are governed by the respective airline's policy. Where a refund is due, we pass it on in full with no additional charges, though transaction fees for bank transfers remain the client's responsibility.</li>
</ul>
<h5><span style={{ color: "#333333" }}><strong>Safaris:</strong></span></h5>
<p>Safari once booked is non-refundable. </p>
<h5><span style={{ color: "#333333" }}><strong>Refund Mode:</strong></span></h5>
<p>Refunds for payments made via card will be returned to the original card used at the time of booking. For payments made via wire transfer, refunds will be issued as travel credits, valid for use towards any India travel booking made within one year.</p>
</div>
    </div>
    </div>
    </div>
    </>
  );
}

export default Term_Condition;